import script from "./Header.vue?vue&type=script&setup=true&lang=ts"
export * from "./Header.vue?vue&type=script&setup=true&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=62772b9c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2158973318/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62772b9c"]])

export default __exports__